import {
  backgroundPositionClassMap,
  mobileVerticalPositionClassMap,
  desktopVerticalPositionClassMap,
} from './constants';
import MainSliderContent from './MainSliderContent';
import ResponsiveSliderImage from './ResponsiveSliderImage';
import type { MainSliderItem } from './types';
import { cn, getButtons } from './utils';

interface BackgroundSlideProps {
  slide: MainSliderItem;
}

const BackgroundSlide = ({ slide }: BackgroundSlideProps) => {
  const textPosition = slide.textPosition ?? 'right';
  const mobileVerticalPosition = slide.mobileTextVerticalPosition ?? 'center';
  const desktopVerticalPosition = slide.textVerticalPosition ?? 'center';
  const buttons = getButtons(slide.buttons, slide.button);

  const imageFitClass =
    slide.imageFit === 'contain' ? 'object-contain' : 'object-cover';

  return (
    <div
      className={cn(
        'relative h-full overflow-hidden rounded-2xl shadow-sm',
        slide.slideClassName,
      )}
    >
      <ResponsiveSliderImage
        imagePath={slide.imagePath}
        mobileImagePath={slide.mobileImagePath}
        imageAlt={slide.imageAlt}
        className="absolute inset-0 h-full w-full"
        imageClassName={cn(
          imageFitClass,
          slide.imagePositionClassName,
          slide.imageClassName,
        )}
        mobileImageClassName={slide.mobileImageClassName}
        objectFit={slide.imageFit === 'contain' ? 'contain' : 'cover'}
        priority
      />

      <div
        className={cn('absolute inset-0 bg-black/10', slide.overlayClassName)}
      />

      <div
        className={cn(
          'tablet:p-10 relative z-10 flex h-full p-6',
          backgroundPositionClassMap[textPosition],
          mobileVerticalPositionClassMap[mobileVerticalPosition],
          desktopVerticalPositionClassMap[desktopVerticalPosition],
          slide.innerClassName,
        )}
      >
        <div
          className={cn(
            'tablet:p-6 w-full max-w-md rounded-xl bg-white/90 p-6 shadow-xl backdrop-blur',
            slide.textBoxClassName,
          )}
        >
          <MainSliderContent
            content={slide.content}
            buttons={buttons}
            textPosition="left"
            className={slide.contentClassName}
            richTextStyles={slide.richTextStyles}
            buttonClassName={slide.buttonClassName}
            buttonsClassName={slide.buttonsClassName}
            buttonAlignment={slide.buttonAlignment} // Add this
          />
        </div>
      </div>
    </div>
  );
};

export default BackgroundSlide;
